import { type UseQueryResult, useQueries } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationInfosResponse } from '../types'

export const useApplicationsDetails = (applicationIds: number[]) => {
  return useQueries({
    queries: applicationIds.map((id) => ({
      queryKey: ['applications', id],
      queryFn: () =>
        fetchApiWithToken<ApplicationInfosResponse>({
          method: 'get',
          url: `/v1/applications/${id}`
        })
    })),
    combine: (results: UseQueryResult<ApplicationInfosResponse>[]) => ({
      applications: results
        .map((result) => result.data)
        .filter((application) => application !== undefined),
      isLoading: results.some((result) => result.isLoading)
    })
  })
}
